
// 当前前台是否为开发模式
const isDev = process.env.NODE_ENV === 'development1'
let merchantUrl = isDev ? 'http://192.154.0.162' : 'https://m.bjftyx.net/merchant'
let merchantPortUrl = isDev ? 'http://192.168.0.162:8083' : 'https://mtest.bjftyx.net/merchant-api'
let merchantApiUrl = isDev ? 'http://192.168.0.162:8083' : 'https://m.bjftyx.net/merchant-api'
switch (process.env.VUE_APP_APP_HOST) {
  case 'development'://测试
    merchantUrl = 'https://mtest.bjftyx.net/merchant'
    merchantPortUrl = 'https://mtest.bjftyx.net/merchant-api'
    merchantApiUrl = 'https://mtest.bjftyx.net/merchant-api'
    break
  case 'production'://正式
    merchantUrl = 'https://m.bjftyx.net/merchant'
    merchantPortUrl = 'https://m.bjftyx.net/merchant-api'
    merchantApiUrl = 'https://m.bjftyx.net/merchant-api'
    break
}
export default {
  pageSize: 10,
  merchantUrl: merchantUrl,
  merchantPortUrl: merchantPortUrl,
  merchantApiUrl: merchantApiUrl,//文件上传
  isDev: true,
}


